module.exports = __webpack_public_path__ + "static/media/fuel1.f5124eeb.svg";